<app-header-one></app-header-one>

<div class="page-title-area page-title-bg2">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Case Study Details</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Case Study Details</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="case-study-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="case-study-details-image">
                    <img src="assets/img/case-study-image/img1.jpg" alt="projects">
                    <a href="https://www.youtube.com/watch?v=bk7McNUjWgw" class="popup-youtube"><i class="flaticon-play-button"></i></a>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="case-study-details-image">
                    <img src="assets/img/case-study-image/img2.jpg" alt="projects">
                    <a href="assets/img/case-study-image/img2.jpg" class="popup-btn"><i class="fas fa-plus"></i></a>
                </div>
            </div>

            <div class="col-lg-12 col-md-12">
                <div class="case-study-details-desc">
                    <h3>Top Emerging Modes of Home</h3>

                    <p>Lorem ipsum dolor sit amet, conse cte tuer adipiscing elit, sed diam no nu m nibhie eui smod. Facil isis atve eros et accumsan etiu sto odi dignis sim qui blandit praesen lup ta de er. At molestiae appellantur pro. Vis wisi oportere per ic ula ad, ei latine prop riae na, mea cu purto debitis.</p>

                    <div class="features-text">
                        <h4><i class="fas fa-check"></i> Core Development</h4>
                        <p>No fake products and services. The customer is king, their lives and needs are the inspiration.</p>
                    </div>

                    <div class="features-text">
                        <h4><i class="fas fa-check"></i> Define Your Choices</h4>
                        <p>No fake products and services. The customer is king, their lives and needs are the inspiration.</p>
                    </div>

                    <p>Nost rud no eos, no impedit dissenti as mea, ea vide labor amus neglegentur vix. Ancillae intellegat vix et. Sit causae laoreet nolu ise. Ad po exerci nusquam eos te. Cu altera expet enda qui, munere oblique theo phrastu ea vix. Ne nec modus civibus modera tius, sit ei lorem doctus. Ne docen di verterem reformidans eos. Cu altera expetenda qui, munere oblique theophr astus ea vix modus civiu mod eratius.</p>

                    <div class="case-study-details-info">
                        <div class="single-info-box">
                            <h4>Client</h4>
                            <span>James Anderson</span>
                        </div>

                        <div class="single-info-box">
                            <h4>Category</h4>
                            <span>Insurance, Home</span>
                        </div>

                        <div class="single-info-box">
                            <h4>Date</h4>
                            <span>February 28, 2020</span>
                        </div>

                        <div class="single-info-box">
                            <h4>Share</h4>
                            <ul class="social">
                                <li><a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-instagram"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                            </ul>
                        </div>

                        <div class="single-info-box">
                            <a href="#" target="_blank" class="default-btn">Live Preview <span></span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>